import type { AxiosResponse } from 'axios';

import { HomepageRebookingProfile } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import 'axios';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const GET_REBOOKING_PROFILES_URL: string = fullApiUrl(
  'frontend/homepage-rebooking-profiles/'
);

export const get = async (): Promise<AxiosResponse<HomepageRebookingProfile[]>> => {
  const ai = getAxiosInstance();
  try {
    const res = await ai.get<Snakeify<HomepageRebookingProfile[]>>(GET_REBOOKING_PROFILES_URL);

    const camelizedData = camelize(res.data, true);

    return { ...res, data: camelizedData };
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while fetching the rebooking profiles.');
  }
};
